var _style, _g, _path, _circle, _g2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCowo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46 46",
    style: {
      enableBackground: "new 0 0 46 46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill-rule:evenodd;clip-rule:evenodd;fill:#E8773F;enable-background:new    ;}\n\t.st1{fill:#A8522C;}\n\t.st2{fill:#E8773F;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_02---2021-UI-Update---Mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Flexi-fesk-attivo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Background-Copy-3",
    className: "st0",
    d: "M23,0c12.7,0,23,10.3,23,23S35.7,46,23,46S0,35.7,0,23S10.3,0,23,0z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23,13.2c1.8,0,3.3-1.5,3.3-3.3S24.8,6.6,23,6.6c-1.8,0-3.3,1.5-3.3,3.3C19.7,11.7,21.2,13.2,23,13.2z M23,7.9 c1.1,0,2,0.9,2,2s-0.9,2-2,2c-1.1,0-2-0.9-2-2S21.9,7.9,23,7.9z M18.5,19.7h9c0.8,0,1.4-0.7,1.4-1.5v-0.4c0-1.1-0.5-2.1-1.4-2.6 c-1-0.6-2.7-1.4-4.5-1.4c-1.8,0-3.4,0.7-4.5,1.4c-0.9,0.5-1.4,1.5-1.4,2.6v0.4C17.1,19.1,17.7,19.7,18.5,19.7L18.5,19.7z M18.4,17.8 c0-0.6,0.3-1.2,0.8-1.5c0.9-0.5,2.3-1.2,3.8-1.2s2.9,0.6,3.8,1.2c0.5,0.3,0.8,0.9,0.8,1.5v0.4c0,0.1-0.1,0.2-0.1,0.2l-9,0 c0,0-0.1-0.1-0.1-0.2L18.4,17.8L18.4,17.8z M14.5,28.9c1.8,0,3.3-1.5,3.3-3.3c0-1.8-1.5-3.3-3.3-3.3c-1.8,0-3.3,1.5-3.3,3.3 C11.2,27.4,12.7,28.9,14.5,28.9z M14.5,23.7c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2C12.5,24.5,13.4,23.7,14.5,23.7z M19,30.9 c-1-0.6-2.7-1.4-4.5-1.4S11,30.3,10,30.9c-0.9,0.5-1.4,1.5-1.4,2.6v0.4c0,0.8,0.6,1.5,1.4,1.5h9c0.8,0,1.4-0.7,1.4-1.5v-0.4 C20.4,32.4,19.8,31.4,19,30.9L19,30.9z M19.1,33.9c0,0.1-0.1,0.2-0.1,0.2l-9,0c0,0-0.1-0.1-0.1-0.2v-0.4c0-0.6,0.3-1.2,0.8-1.5 c0.9-0.5,2.3-1.2,3.8-1.2s2.9,0.6,3.8,1.2c0.5,0.3,0.8,0.9,0.8,1.5L19.1,33.9z M31.5,28.9c1.8,0,3.3-1.5,3.3-3.3 c0-1.8-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3C28.2,27.4,29.7,28.9,31.5,28.9z M31.5,23.7c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2 c-1.1,0-2-0.9-2-2C29.6,24.5,30.4,23.7,31.5,23.7z M36,30.9c-1-0.6-2.7-1.4-4.5-1.4c-1.8,0-3.4,0.7-4.5,1.4 c-0.9,0.5-1.4,1.5-1.4,2.6v0.4c0,0.8,0.6,1.5,1.4,1.5h9c0.8,0,1.4-0.7,1.4-1.5v-0.4C37.4,32.4,36.9,31.4,36,30.9L36,30.9z  M36.1,33.9c0,0.1-0.1,0.2-0.1,0.2l-9,0c0,0-0.1-0.1-0.1-0.2v-0.4c0-0.6,0.3-1.2,0.8-1.5c0.9-0.5,2.3-1.2,3.8-1.2s2.9,0.6,3.8,1.2 c0.5,0.3,0.8,0.9,0.8,1.5L36.1,33.9L36.1,33.9z M26.3,28.9c0.2,0,0.4-0.1,0.5-0.2c0.2-0.3,0.2-0.7-0.1-0.9l-3-2.4v-3.6 c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7v3.6l-3,2.4C19,28,19,28.4,19.2,28.7c0.1,0.2,0.3,0.2,0.5,0.2c0.1,0,0.3,0,0.4-0.1 l2.9-2.3l2.9,2.3C26,28.9,26.1,28.9,26.3,28.9L26.3,28.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    className: "st2",
    cx: 37.3,
    cy: 37.3,
    r: 8.7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon-_-small-_-add-copy-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st3",
    d: "M41.7,33v7.8H40V36l-6.2,6.2L32.6,41l6.3-6.3H34V33H41.7L41.7,33z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCowo);
export default __webpack_public_path__ + "static/media/cowo.db1dcf29da95ce5cadf0eff0dc11e88b.svg";
export { ForwardRef as ReactComponent };